import * as React from "react";
import { connect } from "react-redux";
import MyChartDataTile from "../dashboard/MyChartDataTile";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as d from "../../reducers/domainReducer";
import { getFirstName } from "../../helpers/formatting";
import SectionLoadingError from "../common/SectionLoadingError";
import { PageHeading } from "../ecosystem/mybswh";

class LinkedDevices extends React.Component {

    constructor(props) {
        super(props);
        this.isMobileQueryValue = Tools.isMobileQuery(props.location);
        this.isFromMobile = false;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.LinkedAccounts.ComponentDidMount", new Date(), Tools.getURLPath());
        this.isFromMobile = this.isMobileQueryValue || Tools.getItemFromSessionStorage('isMobile') || this.props.MobileOnQueryString;
    }

    render() {
        const { serverData, epicEHRDown, hasMyChart, HpFhirConsents, isProxyUser, currentUser, primaryUser } = this.props;
        let displayName = '';
        if (currentUser && typeof primaryUser?.externalId !== 'undefined' &&
            currentUser?.externalId !== primaryUser?.externalId && currentUser?.displayName) {
            displayName = getFirstName(currentUser?.displayName);
        }

        return (
            <div className="container-fluid body-content linked-devices-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        {isProxyUser
                            ? <SectionLoadingError
                                message={`This feature is not available to ${displayName ? displayName : 'you'}.`}
                                sectionErrorClass="not-available-error"
                                titleIcon="icon-log-out" />
                            : <>
                                <PageHeading
                                    heading="App & Device Access"
                                    proxyName={displayName}
                                />

                                <div className="row">
                                    <div className="col-12">
                                        <h2 className="page-heading section-heading">Insurance</h2>
                                        <h3>Services Accessing My Account</h3>
                                        {HpFhirConsents && HpFhirConsents.length > 0
                                            ? <p><Link to={{ pathname: "/hpfhirconsent" }}>View apps</Link> that have permission to access your data.</p>
                                            : <>
                                                <p>You’ve given the following apps permission to access your data.</p>
                                                <SectionLoadingError message={"You have not authorized any applications."} sectionErrorClass="no-results-error" />
                                            </>
                                        }
                                    </div>
                                </div>
                                {hasMyChart && !epicEHRDown && <>
                                    <div className="row page-heading-container--dt">
                                        <div className="col-12 col-md-6">
                                            <h2 className="page-heading section-heading dt-heading">Medical Records</h2>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <MyChartDataTile mode="oauthreview" title="Medical Records Apps and Devices" navigation="hide" serverData={serverData} isSubSection={true} />
                                        </div >
                                    </div>
                                    </>
                                }
                            </>
                        }
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData,
        epicEHRDown: state.common.epicEHRDown,
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        HpFhirConsents: state.sso.hpConsentList || [],
        MobileOnQueryString: state.domain.mq,
        isProxyUser: state.domain.ip,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
    };
};

export default connect(mapStateToProps, null)(LinkedDevices);